import { Layout } from '../components/Layout/Layout';
import { Route, Routes } from 'react-router-dom';
import { LoginIntro } from '../containers/LoginIntro/LoginIntro';

export const LoginIntroPage = () => {
  return (
    <Layout backBtn isAuthLayout={false}>
      <Routes>
        <Route path="/" element={<LoginIntro />} />
        <Route path=":index" element={<LoginIntro />} />
      </Routes>
    </Layout>
  );
};
